module.exports = __webpack_public_path__ + "static/media/john-towner.10a8c89d.jpg";